// @ts-nocheck
import { Overlay } from '@angular/cdk/overlay';
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  forwardRef,
  inject,
} from '@angular/core';
import { EntityFieldsComponent } from '../../dynamic-form/sub-modules/sub-form/entity-fields/entity-fields.component';
import { ErrorOverlayClass } from '../../error-overlay/error-overlay.directive';
import { InputTextComponent } from '../input-text/input-text.component';
import FieldsConfig from './oab.model';

@Component({
  selector: 'lbca-oab',
  templateUrl: './oab.component.html',
  styleUrl: './oab.component.scss',
  imports: [forwardRef(() => EntityFieldsComponent), InputTextComponent],
})
export class OabComponent {
  private overlay = inject(Overlay);
  private elementRef = inject(ElementRef);

  public uf: any = FieldsConfig.uf;
  public registro: any = FieldsConfig.registro;
  public digito: any = FieldsConfig.digito;
  public oab: any;

  private fieldConfiguration: any;
  private fieldItem: any;

  public isRequired!: boolean;
  public isDisabled!: boolean;
  public helperTextValue!: string;
  public labelValue!: string;
  public isLabeled: boolean = true;
  public valueInput!: any;
  public hasError!: boolean;

  private errorPopup!: ErrorOverlayClass;
  private error: any;

  public cardInfo: any;

  @Input()
  set cardData(data: any) {
    this.cardInfo = data;
  }

  @Input()
  set configuration(val) {
    this.fieldConfiguration = val;
  }

  @Input() set field(val) {
    this.fieldItem = val;
  }
  @Input() set require(status: boolean) {
    this.isRequired = status;
  }
  @Input() set disabled(disabled: boolean) {
    this.isDisabled = disabled;
  }
  @Input() set helperText(value: string) {
    this.helperTextValue = value;
  }
  @Input() set label(value: string) {
    this.labelValue = value;
  }
  @Input() set labeled(value: boolean) {
    this.isLabeled = value;
  }

  @Input()
  set value(val: any) {
    if (!val) return;

    this.uf = val.uf;
    this.registro = val.registro;
    this.digito = val.digito;

    this.oab = val.oab;
  }

  @Input('error')
  set err(error) {
    if (error && error.length > 0) {
      this.hasError = true;
      this.errorPopup.setErrors(error);
    } else {
      this.hasError = false;
      this.errorPopup.setErrors([]);
    }
    this.error = error;
  }

  @Output('setError') errorStateEmmiter = new EventEmitter();
  @Output('validState') validStatusEmmiter = new EventEmitter();
  @Output('changeValue') changeValueEmmiter = new EventEmitter();

  constructor() {
    const overlay = this.overlay;
    const elementRef = this.elementRef;

    this.errorPopup = new ErrorOverlayClass(overlay);
    this.errorPopup.setPosition(
      elementRef,
      [
        {
          originX: 'start',
          originY: 'top',
          overlayX: 'start',
          overlayY: 'bottom',
        },
      ],
      0,
      0,
      'bottom',
      'start'
    );
  }

  changeValue(field: any, value: any) {
    field.value = value;
    const uf = this.uf.value || '';
    const registro = this.registro.value || '';
    const digito = this.digito.value || '';
    const oab = uf + registro + digito;

    if (!uf || !registro || !digito) return;

    const finalDataToSend = { uf, registro, digito, oab };

    this.changeValueEmmiter.emit(finalDataToSend);
  }
}
